// extracted by mini-css-extract-plugin
module.exports = {"labelText":"styles_labelText___UCli","helperText":"styles_helperText__tFcRZ"};